import UserProfileContent from './UserProfileContent';

function UserProfile() {
    return (
        <UserProfileContent />
    );
}

export default UserProfile;